import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const MegaMenu = () => {
    const [open, setOpen] = useState(false);
    const [groups, setGroups] = useState([]);
    const btnRef = useRef(null);
    const panelRef = useRef(null);

    useEffect(() => {
        api.get("/topics").then(r => setGroups(r.data?.groups || []));
    }, []);

    // Close on outside click / escape
    useEffect(() => {
        if (!open) return;
        const onClick = (e) => {
            if (panelRef.current && !panelRef.current.contains(e.target) && !btnRef.current?.contains(e.target)) {
                setOpen(false);
            }
        };
        const onEsc = (e) => e.key === "Escape" && setOpen(false);
        document.addEventListener("mousedown", onClick);
        document.addEventListener("keydown", onEsc);
        return () => {
            document.removeEventListener("mousedown", onClick);
            document.removeEventListener("keydown", onEsc);
        };
    }, [open]);

    return (
        <div className="relative" data-testid="mega-menu-root">
            <button
                ref={btnRef}
                onClick={() => setOpen(o => !o)}
                data-testid="mega-menu-trigger"
                className={`px-3 py-1.5 text-sm small-caps tracking-wide transition-colors ${open ? 'accent-liturgy' : 'text-foreground/70 hover:accent-liturgy'}`}
            >
                Explore the Faith
                <span className="ml-1 text-xs">{open ? '▴' : '▾'}</span>
            </button>

            {open && (
                <div
                    ref={panelRef}
                    data-testid="mega-menu-panel"
                    className="absolute left-1/2 -translate-x-1/2 mt-3 w-[min(96vw,980px)] bg-background border border-border shadow-2xl z-50 p-8 rounded-sm"
                    style={{ backgroundColor: "hsl(var(--background))" }}
                >
                    <div className="text-center mb-6">
                        <div className="small-caps text-[10px] text-muted-foreground tracking-widest">
                            33 pathways · one for each year of Christ's earthly life
                        </div>
                        <h3 className="font-serif text-2xl mt-1">Explore the Faith</h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
                        {groups.map(g => (
                            <div key={g.group}>
                                <div className="small-caps text-[10px] accent-liturgy tracking-widest mb-3 border-b border-border/60 pb-1.5">
                                    {g.group}
                                </div>
                                <ul className="space-y-1.5">
                                    {g.topics.map(t => (
                                        <li key={t.slug}>
                                            <Link
                                                to={`/topics/${t.slug}`}
                                                onClick={() => setOpen(false)}
                                                data-testid={`mega-menu-topic-${t.slug}`}
                                                className="group flex items-start gap-2 text-sm text-foreground/80 hover:accent-liturgy transition-colors leading-snug"
                                            >
                                                <span className="text-[10px] mt-0.5 text-muted-foreground/70 tabular-nums">{String(t.num).padStart(2, "0")}</span>
                                                <span className="font-serif">{t.title}</span>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MegaMenu;
